import RadioGroupComponent from './radio-group.component'

const RadioGroupModule = angular.module('cdbl.radio-group', [

])
  .component('cdblRadioGroup', RadioGroupComponent)
  .name

export default RadioGroupModule
